import { app_token, sandbox_status } from "src/utils/leanConfig";

export const updatePaymentSource = (props) => {
  window.Lean.updatePaymentSource({
    app_token: app_token,
    customer_id: props?.customer_id,
    payment_source_id: props?.payment_source_id,
    payment_destination_id: props?.payment_destination_id,
    sandbox: sandbox_status,
    callback: props.callback,
  });
};

export const CreatePaymentSource = (customer_id, bank_identifier, callback) => {
  window.Lean.createPaymentSource({
    app_token: app_token,
    customer_id,
    bank_identifier,
    sandbox: sandbox_status,
    callback,
  });
};

export const Connect = (customerId, callback) => {
    window.Lean.connect({
      app_token: app_token,
      permissions: ["identity", "accounts", "transactions", "balance", "payments"],
      customer_id: customerId,
      sandbox: true,
      callback,
    });
}

export const Pay = (paymentIntentId, callback) => {
  window.Lean.pay({
    app_token: app_token,
    payment_intent_id: paymentIntentId,
    sandbox: true,
    show_balances: false,
    callback,
  });
};